// extracted by mini-css-extract-plugin
export default {"push":"YIK5c","pushInfo":"oBexg"};